module.exports = __webpack_public_path__ + "static/media/sell_request_details_make_2.b90dc13f.png";